var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { action, makeObservable } from 'mobx';
import { observer } from 'mobx-react';
import { AppearState } from '../../../../classes/learnware/LearnwareEnums';
import { Actor_ } from '../../../../components/actor/Actor_';
import { AbfragerAssociateQuestionPart } from '../../questionTypes/Associate/AbfragerAssociateQuestionPart';
let AbfragerQuestionPart = class AbfragerQuestionPart extends React.PureComponent {
    constructor(props) {
        super(props);
        makeObservable(this);
    }
    render() {
        const { question } = this.props;
        const opacity = this.props.question.questionAppear.shouldBeVisible ? 1 : 0;
        return (React.createElement(Actor_, { actor: question.questionPart, structureTemplate: React.createElement(React.Fragment, null,
                React.createElement("div", { "data-aspect": "inner", style: {
                        opacity,
                        transition: 'opacity ' +
                            (question.questionAppear.shouldBeVisible
                                ? '0.20s ease-in' // https://matthewlein.com/tools/ceaser
                                : '0.15s ease-out'),
                        flex: '1 1 auto',
                        display: 'flex',
                        alignItems: 'center',
                        paddingLeft: 25,
                        paddingTop: 4,
                        paddingRight: 10,
                        paddingBottom: 0
                    }, onTransitionEnd: this.handleTransitionEnd }),
                React.createElement(AbfragerAssociateQuestionPart, { question: question })) }));
    }
    // transitionstart event does not exist yet
    handleTransitionEnd(e) {
        const { question } = this.props;
        const target = e.nativeEvent.target;
        if (e.propertyName === 'opacity') {
            if (target.style.opacity === '1') {
                question.questionAppear.appearState = AppearState.Visible;
            }
            if (target.style.opacity === '0') {
                question.questionAppear.appearState = AppearState.Hidden;
            }
        }
    }
};
__decorate([
    action.bound
], AbfragerQuestionPart.prototype, "handleTransitionEnd", null);
AbfragerQuestionPart = __decorate([
    observer
], AbfragerQuestionPart);
export { AbfragerQuestionPart };
